import React, { useState } from 'react';
import clsx from 'clsx';
import TruncateMarkup from 'react-truncate-markup';
import useInApp from '@/hooks/useInApp';
import { NoteState } from '../layout/StandardPhotoGrid';

interface SocialLinkNoteProps {
  media: any;
  orientation: string;
  noteState: NoteState;
  handleSeeNotesClick: (media) => void;
  handleAddNoteClick: (media) => void;
  setRowSpan: (link, noteRowSpan) => void;
}

export default function SocialLinkNote({
  media,
  handleSeeNotesClick,
  noteState,
  orientation,
  handleAddNoteClick,
  setRowSpan,
}: SocialLinkNoteProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const { inPublicMoodbard } = useInApp();

  const handleSeeAllClick = () => {
    setIsExpanded(true);
    setRowSpan(media, 2);
  };

  const handleSeeLessClick = () => {
    setIsExpanded(false);
    setRowSpan(media, 1);
  };

  const handleSeeNote = () => {
    handleSeeNotesClick(media);
    setIsExpanded(false);
  };

  return (
    <>
      {media.note ? (
        <p
          className="font-nhg text-[14px] font-[400] leading-[14px] tracking-[0.15em] text-[#A2EE00] cursor-pointer absolute transform translate-y-[8px]"
          onClick={handleSeeNote}
        >
          {noteState[media.bookmarkId].showNote ? 'HIDE' : 'SEE NOTE'}
        </p>
      ) : inPublicMoodbard ? null : (
        <span
          className="font-nhg font-[400] text-[14px] leading-[14px] tracking-[0.15em] cursor-pointer absolute transform translate-y-[8px]"
          onClick={() => handleAddNoteClick(media)}
        >
          + NOTE
        </span>
      )}

      {media.note && (
        <div
          className={clsx([
            'py-[16px] px-[20px] mt-[30px] bg-[#A2EE00] rounded-[10px]',
            noteState[media.bookmarkId].showNote ? 'block' : 'hidden',
            orientation === 'landscape' ? 'w-[50%]' : 'w-full',
          ])}
        >
          <p className="font-nhg text-[14px] leading-[15.4px] tracking-[0.42px] text-black">
            {!isExpanded ? (
              <TruncateMarkup
                lines={4}
                ellipsis={
                  <span
                    className="see-more-link font-nhg text-[14px] leading-[15.4px] tracking-[0.42px]"
                    onClick={handleSeeAllClick}
                    style={{ color: 'rgba(0, 0, 0, 0.50)', cursor: 'pointer' }}
                  >
                    ...See all
                  </span>
                }
              >
                <span>{media.note}</span>
              </TruncateMarkup>
            ) : (
              <>
                {media.note}
                <span
                  className="see-less-link font-nhg text-[14px] leading-[15.4px] tracking-[0.42px] text-right ml-1 whitespace-nowrap"
                  onClick={handleSeeLessClick}
                  style={{
                    color: 'rgba(0, 0, 0, 0.50)',
                    cursor: 'pointer',
                    marginTop: '0px',
                  }}
                >
                  See less
                </span>
              </>
            )}
          </p>
        </div>
      )}
    </>
  );
}
